<template>
  <div class="row footer">
    <div class="col">
      <span>{{$t("Footer")}}</span>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.footer {
  background-color: #19191a;
  padding: 10px;
}
span {
  color: white;
      font-family: "Trirong", serif;
      letter-spacing: 2px;
      font-weight: bold;
      font-size: small;
}
</style>